import React, { useEffect, useState } from 'react';
import { Alert, Button, Card, CardContent, Container, Stack, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { api } from '../../api';

export function SavedQuizzesPage() {
  const [quizzes, setQuizzes] = useState([]);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const load = async () => setQuizzes(await api.getQuizzes());
  useEffect(() => { load(); }, []);

  return (
    <Container>
      <Stack spacing={3}>
        <Typography variant="h4">Kvizovi</Typography>
        <Typography color="text.secondary">
          Spremljeni kvizovi su prethodno spremljene postavke igre koje možete ponovno otvoriti i urediti.
        </Typography>
        {message && <Alert severity="success">{message}</Alert>}
        {error && <Alert severity="error">{error}</Alert>}
        <Card>
          <CardContent>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Naziv kviza</TableCell>
                  <TableCell>Naslov</TableCell>
                  <TableCell>Igrači</TableCell>
                  <TableCell>Krugovi</TableCell>
                  <TableCell>Akcije</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {quizzes.map((quiz) => (
                  <TableRow key={quiz.id}>
                    <TableCell>{quiz.internalName}</TableCell>
                    <TableCell>{quiz.publicTitle}</TableCell>
                    <TableCell>{quiz.enabledPlayers.join(', ')}</TableCell>
                    <TableCell>{quiz.roundsCount}</TableCell>
                    <TableCell>
                      <Stack direction="row" spacing={1}>
                        <Button size="small" variant="contained" onClick={async () => {
                          try {
                            const loaded = await api.loadQuizToDraft(quiz.id);
                            setMessage(loaded.message);
                            setError('');
                            navigate('/admin/postavke-igre');
                          } catch (err) {
                            setError(err.message);
                            setMessage('');
                          }
                        }}>Uredi</Button>
                        <Button size="small" color="error" onClick={async () => {
                          try {
                            await api.deleteQuiz(quiz.id);
                            setMessage('Kviz je obrisan.');
                            setError('');
                            await load();
                          } catch (err) {
                            setError(err.message);
                            setMessage('');
                          }
                        }}>Obriši</Button>
                      </Stack>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </CardContent>
        </Card>
      </Stack>
    </Container>
  );
}
